<script lang="ts">
	import { getRentalTemplateContext } from "./rental-template-context.svelte";
	const templateContext = getRentalTemplateContext()!;
</script>

<section id="property-details" class="bg-[#f8f8f8]">
	<div class="relative">
		<!-- Mobile: Full width image at top, Desktop: Absolute positioned left side -->
		<div class="md:absolute md:left-0 md:h-full md:w-[45%]">
			<img
				src={templateContext.detailsImage}
				alt="Property Details"
				class="h-[300px] w-full object-cover md:h-full"
				width="800"
				height="533"
				loading="lazy"
			/>
		</div>

		<!-- Main content container -->
		<div class="container mx-auto px-4 py-16">
			<div class="md:flex">
				<!-- Desktop: Spacer div to push content to the right, Mobile: Hidden -->
				<div class="hidden md:block md:w-[45%] md:shrink-0"></div>

				<!-- Content area -->
				<div class="w-full px-0 md:w-[55%] md:px-8">
					<h2 class="mb-6 text-4xl font-medium text-slate-700">PROPERTY DETAILS</h2>
					<hr class="border-primary mb-8 w-[100px] border-2" />

					<div class="grid grid-cols-1 gap-12 md:grid-cols-2">
						<div>
							<h3 class="mb-6 text-2xl font-medium">APARTMENT FEATURES</h3>
							<ul class="space-y-2">
								{#each templateContext.apartmentFeatures as feature}
									<li class="flex">
										<span class="mr-2 flex-shrink-0 font-bold">•</span>
										<span class="flex-1">{feature}</span>
									</li>
								{/each}
							</ul>
						</div>

						<div>
							<h3 class="mb-6 text-2xl font-medium">COMMUNITY FEATURES</h3>
							<ul class="space-y-2">
								{#each templateContext.communityFeatures as feature}
									<li class="flex">
										<span class="mr-2 flex-shrink-0 font-bold">•</span>
										<span class="flex-1">{feature}</span>
									</li>
								{/each}
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
